/* eslint-disable no-plusplus */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';

import { BoardColumn } from './components/boardColumn';
import { SettingsContext } from './components/boardColumn/settingsContext';
import { useBoard } from './hooks/useBoard';
import { BoardAddNewColumn } from './components/boardAddNewColumn';

export const Board = ({
  data,
  setData,
  CardComponent,
  onCreateColumn,
  onNewColumnName,
  onDeleteColumn,
  onMoveCardToAnotherColumn,
  onMoveColumn,
  onScrollEndReached,
  disableVerticalDragging,
}) => {
  const { settings } = useContext(SettingsContext);
  const { scrollableRef } = useBoard({
    settings,
    data,
    setData,
    onMoveCardToAnotherColumn,
    onMoveColumn,
    disableVerticalDragging,
  });

  return (
    <Flex
      sx={{
        height: '100%',
        flexDirection: 'column',
        px: 0,
        py: 0,
      }}
    >
      <Flex
        pt="8px"
        px="10px"
        sx={{
          height: '100%',
          flexDirection: 'row',
          overflowX: 'auto',
          scrollbarColor: 'neutral.50 neutral.200',
          scrollbarWidth: 'thin',
          borderRadius: settings.isBoardMoreObvious ? 'default' : 0,
          border: settings.isBoardMoreObvious ? '2px dashed' : 'none',
        }}
        ref={scrollableRef}
      >
        {data.columns.map((column) => (
          <BoardColumn
            key={column.id}
            column={column}
            CardComponent={CardComponent}
            onNewColumnName={onNewColumnName}
            onDeleteColumn={onDeleteColumn}
            disableVerticalDragging={disableVerticalDragging}
            onEndReached={onScrollEndReached}
          />
        ))}
        {onCreateColumn && <BoardAddNewColumn onCreateColumn={onCreateColumn} />}
      </Flex>
    </Flex>
  );
};

Board.propTypes = {
  data: PropTypes.object.isRequired,
  setData: PropTypes.func.isRequired,
  CardComponent: PropTypes.func.isRequired,
  disableVerticalDragging: PropTypes.bool,
  onNewColumnName: PropTypes.func.isRequired,
  onDeleteColumn: PropTypes.func.isRequired,
  onMoveCardToAnotherColumn: PropTypes.func.isRequired,
  onMoveColumn: PropTypes.func.isRequired,
  onCreateColumn: PropTypes.func,
  onScrollEndReached: PropTypes.func,
};

Board.defaultProps = {
  disableVerticalDragging: false,
  onCreateColumn: null,
  onScrollEndReached: () => {},
};
